import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	ai_feedback_report_consent_checkbox_label: {
		id: 'search_ai.ai_feedback_report_consent_checkbox_label',
		defaultMessage: 'Include my last prompt and response in the feedback.',
		description:
			'Label for the checkbox asking for user consent to include their AI prompt and response in their feedback',
	},
	ai_feedback_provide_additional_feedback_title: {
		id: 'search_ai.ai_feedback_provide_additional_feedback_title',
		defaultMessage: 'Provide additional feedback',
		description:
			'Title text for the provide additional feedback section of the report feedback collector',
	},
	ai_feedback_like_button_tooltip: {
		id: 'search_ai.ai_feedback_like_button_tooltip',
		defaultMessage: 'Good response',
		description: 'Tooltip text for the ai answer component like button',
	},
	ai_feedback_dislike_button_tooltip: {
		id: 'search_ai.ai_feedback_dislike_button_tooltip',
		defaultMessage: 'Bad response',
		description: 'Tooltip text for the ai answer component dislike button',
	},
	ai_feedback_can_contact_checkbox_label: {
		id: 'search_ai.ai_feedback_can_contact_checkbox_label',
		defaultMessage:
			'Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the {privatePolicyLink}',
		description: 'Label for the checkbox to consent to be contacted about their feedback',
	},
	ai_feedback_private_policy_link: {
		id: 'search_ai.ai_feedback_private_policy_link',
		defaultMessage: 'Atlassian Privacy Policy',
		description: 'Link for the private policy',
	},
	ai_feedback_reason_out_of_date: {
		id: 'search_ai.ai_feedback_reason_out_of_date',
		defaultMessage: 'Out of date',
		description: 'Feedback reason option for outdated content',
	},
	ai_feedback_reason_inaccurate: {
		id: 'search_ai.ai_feedback_reason_inaccurate',
		defaultMessage: 'Inaccurate',
		description: 'Feedback reason option for inaccurate content',
	},
	ai_feedback_reason_too_long: {
		id: 'search_ai.ai_feedback_reason_too_long',
		defaultMessage: 'Too long',
		description: 'Feedback reason option for response being too long',
	},
	ai_feedback_reason_too_short: {
		id: 'search_ai.ai_feedback_reason_too_short',
		defaultMessage: 'Too short',
		description: 'Feedback reason option for response being too short',
	},
	ai_feedback_reason_wrong_sources: {
		id: 'search_ai.ai_feedback_reason_wrong_sources',
		defaultMessage: 'Wrong sources',
		description: 'Feedback reason option for wrong sources',
	},
	ai_feedback_reason_inappropriate: {
		id: 'search_ai.ai_feedback_reason_inappropriate',
		defaultMessage: 'Inappropriate or harmful',
		description: 'Feedback reason option for inappropriate or harmful content',
	},
	ai_feedback_reason_other: {
		id: 'search_ai.ai_feedback_reason_other',
		defaultMessage: 'Other',
		description: 'Feedback reason option for other issues',
	},
	ai_feedback_reason_up_to_date: {
		id: 'search_ai.ai_feedback_reason_up_to_date',
		defaultMessage: 'Up to date',
		description: 'Positive feedback reason option for up to date content',
	},
	ai_feedback_reason_accurate: {
		id: 'search_ai.ai_feedback_reason_accurate',
		defaultMessage: 'Accurate',
		description: 'Positive feedback reason option for accurate content',
	},
	ai_feedback_reason_helpful: {
		id: 'search_ai.ai_feedback_reason_helpful',
		defaultMessage: 'Helpful',
		description: 'Positive feedback reason option for helpful content',
	},
	ai_feedback_reason_following_instructions: {
		id: 'search_ai.ai_feedback_reason_following_instructions',
		defaultMessage: 'Following instructions',
		description: 'Positive feedback reason option for following instructions',
	},
	ai_feedback_reason_good_sources: {
		id: 'search_ai.ai_feedback_reason_good_sources',
		defaultMessage: 'Good sources',
		description: 'Positive feedback reason option for good sources',
	},
	ai_feedback_flag_title: {
		id: 'search_ai.ai_feedback_flag_title',
		defaultMessage: 'Thank you',
		description: 'Title text for the feedback flag',
	},
	ai_feedback_flag_description: {
		id: 'search_ai.ai_feedback_flag_description',
		defaultMessage: 'Your feedback helps to improve Rovo',
		description: 'Description text for the feedback flag',
	},
	ai_feedback_flag_close_action: {
		id: 'search_ai.ai_feedback_flag_close_action',
		defaultMessage: "I'm done",
		description: 'Close action text for the feedback flag',
	},
	ai_feedback_what_hasnt_gone_well_title: {
		id: 'search_ai.ai_feedback_what_hasnt_gone_well_title',
		defaultMessage: "What hasn't gone well?",
		description: "Title text for the what hasn't gone well section of the feedback collector",
	},
	ai_feedback_what_has_gone_well_title: {
		id: 'search_ai.ai_feedback_what_has_gone_well_title',
		defaultMessage: 'What has been going well?',
		description: 'Title text for the what has been going well section of the feedback collector',
	},
	ai_feedback_additional_feedback_label: {
		id: 'search_ai.ai_feedback_additional_feedback_label',
		defaultMessage: 'Additional feedback',
		description: 'Label text for the additional feedback section of the feedback collector',
	},
	ai_feedback_additional_feedback_placeholder: {
		id: 'search_ai.ai_feedback_additional_feedback_placeholder',
		defaultMessage: 'Tell us more',
		description: 'Placeholder text for the additional feedback section of the feedback collector',
	},
});
